import React from "react";
import FWStyle from "./FormWindow.module.css";

const FormWindow = (props:any) => {
  return <div className={`${FWStyle.root}`}>{props.children}</div>;
};

export default FormWindow;
